<template>
    <side-container v-if="visible"
        :width="450"
        :headerTitle="'会员卡设置'"
        :isShowFooterBtn="false"
        :isLoading="isLoading"
        class="header"
        @close="close"
    >
        <div class="body">
            <div class="card-box">
                <div class="card">
                    <div class="title">
                        <img class="avatar" :src="shopImg" />
                        <p>{{ shopInfo.shop_name }}</p>
                    </div>
                    <img src='./images/membercard-orange.svg' v-if="isSelcet === 1" />
                    <img src='./images/membercard-purple.svg' v-if="isSelcet === 2" />
                    <img src='./images/membercard-green.svg' v-if="isSelcet === 3" />
                </div>
            </div>
            <div class="config">
                <div class="config_left">
                    <div class="top">
                        <p class="header-title">店铺logo</p>
                    </div>

                        <div class="center">
                            <template  v-if="imageUrl === ''">
                                <qiniu-upload
                                    list-type="picture-card"
                                    :imgLimit="300"
                                    :useDefault="false"
                                    @upload-success="ShopLogouploadSuccess">
                                    <i slot="default" class="el-icon-plus"/>
                                </qiniu-upload>
                            </template>
                            <template v-else>
                                <div class="pre-img_box">
                                    <el-image
                                        :style="{width: '40px', height: '40px', display: 'block', margin: 'auto', borderRaduis: '4px'}"
                                        :src='imageUrl'
                                        :preview-src-list="[imageUrl]"
                                    />
                                    <div class="delete" @click="delteShopLogoImg">
                                        <i class="iconfont icongonggongguanbi2"></i>
                                    </div>
                                </div>
                            </template>
                            </div>
                        <p class="align-c fs-12 color-999 mt-10 lh-16">点击上传店铺logo</p>
                        <p class="align-c fs-12 color-999 lh-16">图片大小不能超过2M</p>

                </div>
                <div class="config_right">
                    <div class="top">
                        <p class="header-title">主题选择</p>
                    </div>
                    <div class="center">
                        <div class="item orange" @click="chooseThem(1)">
                            <i class="iconfont icongonggongzhengque1-copy" v-if="isSelcet === 1"></i>
                        </div>
                        <div class="item purple" @click="chooseThem(2)">
                            <i class="iconfont icongonggongzhengque1-copy" v-if="isSelcet === 2"></i>
                        </div>
                        <div class="item green" @click="chooseThem(3)">
                            <i class="iconfont icongonggongzhengque1-copy" v-if="isSelcet === 3"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="recharge">
                <div class="left">
                    <p>小程序自主充值</p>
                    <p>开启后，会员可在“甜杏”小程序自主按充值规则充值</p>
                </div>
                <div class="right">
                    <el-switch
                        v-model="checked"
                        active-color="#009688"
                        inactive-color="#ddd">
                    </el-switch>
                </div>
            </div>

            <div class="concat">
                <p class="header-title ">店铺联系方式</p>
            </div>
            <div class='concat_content'>
                <div class="_phone-box">
                    <div class='phone'>
                        <el-checkbox v-model="isCheckedPhone" class='all'>手机号：</el-checkbox>
                    </div>
                    <div class="_input_box">
                        <el-input
                        class='_phone_input'
                        :class="{err_input: phoneError}"
                        maxlength="11"
                        v-model="phone"
                        show-word-limit
                        @focus="focusEvent"
                        @input="onInputEvent"
                        @change="inputChange"
                        placeholder="填写手机号后顾客可通过电话联系您" />
                        <div class="_err-text" v-if="phoneError">请填写正确的手机号格式</div>
                    </div>
                </div>
                <div class="_wechat">
                    <el-checkbox v-model="isCheckedWechat"  class='all'>微信号：</el-checkbox>
                    <div class="erweima">
                        <template  v-if="wechatUrl === ''">
                                <qiniu-upload
                                    list-type="picture-card"
                                    :imgLimit="300"
                                    :useDefault="false"
                                    @upload-success="WechatLogouploadSuccess">
                                    <i slot="default" class="el-icon-plus"/>
                                </qiniu-upload>
                            </template>
                            <template v-else>
                                <div class="pre-img_box">
                                    <el-image
                                        :style="{width: '40px', height: '40px', display: 'block', margin: 'auto', borderRaduis: '4px'}"
                                        :src='wechatUrl'
                                        :preview-src-list="[wechatUrl]"
                                    />
                                    <div class="delete" @click="deleteWechatImg">
                                        <i class="iconfont icongonggongguanbi2"></i>
                                    </div>
                                </div>
                        </template>
                    </div>
                    <div class='tip-text'>
                        <p>点击上传微信二维码</p>
                        <p>图片大小不能超过2M</p>
                    </div>
                </div>
            </div>


        </div>
        <!--  footer  -->
        <div
            class="footer"
            slot="footer">
            <div
                class ="btn-wrapper">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editMemberCardInfo"
                    :loading="isBtnLoding"
                    :disabled="isCanConfirm"
                >确认</el-button>
            </div>
        </div>
    </side-container>
</template>

<script lang='ts'>
import { createComponent, ref, SetupContext, watch, onBeforeMount} from '@vue/composition-api'
import SideContainer from '@/components/layout/side-container-style2.vue'
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'
import { useStore } from '../../../store'
import { getQiniuImgUrl } from '../../../assets/ts/qiniu'
import $fetch from '../../../api'
import { Message } from 'element-ui'
import { openMessage } from '../../../utils/system'
export default createComponent ({
    setup(
        props: any,
        ctx: SetupContext
    ) {
        const store = useStore()
        const shopInfo = (store.state as any).shop.shopInfo
        const isCanConfirm = ref(true) // 是否可以确认提交
        const isLoading = ref(false)
        const isBtnLoding = ref(false) // 提交按钮的lodging
        const isSelcet = ref('')
        const visible = ref(false)
        const shopImg = ref('') // 卡片上的店铺头像
        const imageUrl = ref('') // 店铺logo
        const wechatUrl = ref('') // 微信logo
        const checked = ref(true)  // 会员充值打开的按钮
        const isCheckedPhone = ref(true) // 手机号放开
        const phone = ref('')
        const phoneError = ref(false) // 手机号错误
        const isCheckedWechat = ref(true) // 微信放开
        const onlinePayment = ref(1) // 在线支付状态
        let shopLogokey = '' // 图片key值
        let erweimaKey = '' // 二维码key值


        // 监听key值是否存在
        watch(() => {
            // imageUrl 必填  wechatUrl 选填  phone 选填 （ wechatUrl， phone） 必须填一个 
            if (!imageUrl.value) {
                isCanConfirm.value = true
            } else {
                if (isCheckedWechat.value) {  // 表示需要上传二维码
                    if (!wechatUrl.value) {
                       return isCanConfirm.value = true 
                    }
                }
                if (!isCheckedWechat.value && !isCheckedPhone.value) {  // 两者都不选，也不准提交
                    return isCanConfirm.value = true 
                }

                if (isCheckedPhone.value) {  // 表示需要手机号要填写(也需要正则校验)
                    if (phone.value.length !== 11 ) {
                        return isCanConfirm.value = true
                    }
                    if ( phone.value.length === 11) {
                        if (phoneError.value) {
                            return isCanConfirm.value = true
                        }
                    }
                }
                isCanConfirm.value = false
            }
        })

        function open() {
            getMemberConfigInfo()
            visible.value = true
        }

        function getMemberConfigInfo() {
            isLoading.value = true
            $fetch.post({
                url: '/shop/getshopinfo',
                params: {
                    shop_id: shopInfo.id
                }
            }).then( res => {
                ctx.root.$store.commit('shop/setShopInfo', res)
                isLoading.value = false
                phoneError.value = false
                onlinePayment.value = res.online_payment
                const memberConfig = res.membercard_config
                isSelcet.value = memberConfig.card_face_theme ? memberConfig.card_face_theme : 1
                shopImg.value = getQiniuImgUrl(res.logo_image_url)
                imageUrl.value = res.logo_image_url ? getQiniuImgUrl(res.logo_image_url) : ''
                checked.value = memberConfig.app_recharge === 0 ? true : false,
                isCheckedPhone.value = memberConfig.contact_method_list.includes(0) ? true : false,
                isCheckedWechat.value = memberConfig.contact_method_list.includes(1) ? true : false,
                phone.value = res.phone,
                wechatUrl.value = memberConfig.wx_qr_code_img ? getQiniuImgUrl( memberConfig.wx_qr_code_img, 800 ) : ''
                erweimaKey = memberConfig.wx_qr_code_img ? memberConfig.wx_qr_code_img : ''
            })
        }

        function close() {
            visible.value = false
        }

        function chooseThem(key) {
            isSelcet.value = key
        }

        function ShopLogouploadSuccess(res) {
            imageUrl.value = res.imgSrc
            shopLogokey = res.key
        }

         function delteShopLogoImg() {
            imageUrl.value = ''
            shopLogokey = ''
        }

        function WechatLogouploadSuccess(res) {
            wechatUrl.value = res.imgSrc
            erweimaKey = res.key
        }

        function deleteWechatImg() {
            wechatUrl.value = ''
            erweimaKey = ''
        }

        function focusEvent() {
            phoneError.value = false
        }

        function onInputEvent(value) {
            if (value.length ===  11) {
                const reg = /^[1]([3-9])[0-9]{9}$/
                phoneError.value = !reg.test(value)
            }
        }

        function inputChange(value) {
            const reg = /^[1]([3-9])[0-9]{9}$/
            phoneError.value = !reg.test(value)
        }

       
        /**
         *  修改会员卡信息
         */
        function editMemberCardInfo() {
            // 联系方式处理

            const params = {
                shop_logo_img: shopLogokey || undefined,
                card_face_theme: isSelcet.value ? isSelcet.value : 1,
                app_recharge: checked.value ? 0 : -1,
                phone: phone.value || undefined,
                wx_qr_code_img: erweimaKey || undefined,
                contact_method: [ isCheckedPhone.value ? 0 : undefined, isCheckedWechat.value ? 1 : undefined].filter( item => item !== undefined )
            }
            isBtnLoding.value = true
            $fetch.post({
                url: '/shop/updatememberconfig',
                params
            }).then( res => {
                openMessage('success', '设置成功')
                isBtnLoding.value = false
                visible.value = false
                getMemberConfigInfo()
            }).catch( e  => {
                openMessage('error', '设置失败')
                isBtnLoding.value = false
            })
        }
        return {
            isLoading,
            isBtnLoding,
            isSelcet,
            chooseThem,
            ShopLogouploadSuccess,
            WechatLogouploadSuccess,
            imageUrl,
            wechatUrl,
            shopImg,
            checked,
            isCheckedPhone,
            phone,
            phoneError,
            focusEvent,
            onInputEvent,
            inputChange,
            isCheckedWechat,
            shopInfo,
            onlinePayment,
            getQiniuImgUrl,
            delteShopLogoImg,
            deleteWechatImg,
            editMemberCardInfo,
            open,
            visible,
            close,
            isCanConfirm
        }
    },
    components: {
        SideContainer,
        QiniuUpload
    }
})
</script>

<style lang="scss" scoped>
.card-box {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    width: 100%;
    height: 170px;
    overflow: hidden;
    background: linear-gradient(to bottom, #fff, #f5f5f5);

    .card {
        position: relative;
        margin: 17px 55px;
        height: 136px;
        border-radius: 8px;
        box-shadow: 0 10px 30px -20px #ccc;

        > img {
            width: 100%;
            height: 100%;
        }

        .title {
            display: flex;
            align-items: center;
            top: 15px;
            left: 0;
            position: absolute;
            padding: 0 15px;
            width: 100%;
            height: 40px;

            .avatar {
                margin-right: 8px;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                border: 2px solid rgba(255,255,255,0.30);
            }

            > p {
                font-size: 19px;
                color: #fff;
            }
        }


    }
}

.config {

    display: flex;
    margin: 0 10px;
    // background: red; 
    height: 153px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .config_left,  .config_right{
        flex: 1;
        margin-left: 7px;

        .top {
            display: flex;
            align-items: center;
            height: 52px;
        }
    }

    .config_right {
        .center {
            display: flex;
            height: 40px;

            .item {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 22px;
                width: 40px;
                height: 40px;
                box-shadow: 0 10px 30px -20px #A9A9A9;
                border-radius: 4px;
                color: #fff;
                cursor: pointer;
            }

            .orange {
                background: linear-gradient(to right,#F4B464 ,#E88F4B);
            }

            .purple {
                background: linear-gradient(to right, #D33EDE, #3E4EF9)
            }
            .green {
                background: linear-gradient(to right, #53D14D, #09B53B)
            }

        }
    }

    .config_left {
        .center {
            display: flex;
            justify-content: center;

            ::v-deep .el-upload--picture-card {
                display: inline-block;
                width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;

                .el-icon-plus {
                    font-size: 20px;
                }
            }

            .pre-img_box {
                position: relative;
                width: 40px;
                height: 40px;
                cursor: pointer;

                .delete {
                    position: absolute;
                    top: -10px;
                    right: -10px;
                }
            }
        }
    }

}
.recharge {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    margin: 20px 10px 0; 

    .left {
        flex: 1;

        p {
            &:nth-of-type(1) {
                font-size: 14px;
                color: #333; 
                line-height: 20px;
            }
            &:nth-of-type(2) {
                font-size: 12px;
                color: #999;
                line-height: 16px;
            }
        }
    }
    
    .right {
        width: 40px;
        height: 20px;
    }
}

.concat {
    margin-top: 20px;
    padding: 0 10px;

    > p {
        margin-left: 7px;
    }
}


::v-deep .el-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
    font-weight: normal;
    padding-left: 12px;
}

::v-deep .el-checkbox .el-checkbox__input + .el-checkbox__label {
    font-weight: normal;
    padding-left: 12px;
}

::v-deep .el-input .el-input__count .el-input__count-inner {
    font-size: 14px;
}
.concat_content {
    margin-top: 12px;
    padding: 0 20px;

    ._wechat {
        display: flex;
        align-items: center;
        min-height: 40px;
    }

    ._phone-box {
        display: flex;

        .phone {
            display: flex;
            align-items: center;
            height: 40px;
        }
        ._phone_input {
            height: 40px;
            // line-height: 40px;
            margin-left: 10px;
            border-radius: 5px;
        }

        .err_input {
                // border: 1px solid #FF2A2A!important;
                
                ::v-deep .el-input__inner {
                    border-color: #FF2A2A!important;
                }
        }

        ._input_box {
            width: 100%;

            ._err-text {
                padding-top: 4px;
                padding-left: 12px;
                font-size: 12px;
                color: #FF2A2A;
            }
            
        }
    }

    ._wechat {
        margin-top: 12px;

        .erweima {
            margin-left: 12px;
            position: relative;
            display: flex;
            justify-content: center;

            ::v-deep .el-upload--picture-card {
                display: inline-block;
                width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;

                .el-icon-plus {
                    font-size: 20px;
                }
            }

            .pre-img_box {
                position: relative;
                width: 40px;
                height: 40px;
                cursor: pointer;

                .delete {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                }
            }
        }

        .tip-text {
            margin-left: 12px;
            > p {
                font-size: 12px;
                line-height: 16px;
                color: #999999;
            }
        }

    }


}

.footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 7px 12px;
}
</style>